import { useDispatch } from 'react-redux';
import { beginApiCall, endApiCall } from '../store/api/api-status-action';

export const useBusy = (): [
    (isBusy: boolean, timeout?: number) => Promise<void>
] => {
    const dispatch = useDispatch();

    const setIsBusy = async (
        isBusy: boolean,
        timeout?: number
    ): Promise<void> => {
        if (isBusy) {
            dispatch(beginApiCall('BUSY'));
            if (timeout) {
                setTimeout(() => {
                    dispatch(endApiCall());
                }, timeout);
            }
        } else {
            dispatch(endApiCall());
        }
    };

    return [setIsBusy];
};
